<template>
  <InsurancePlanFilter
    class="filter"
    :class="breakpointModifierClass"
    close-on-select
    inline
    :model-value="insurancePlan"
    :non-clearable="nonClearable"
    @update:model-value="insuranceChanged"
  >
    <template #activator>
      <sp-button
        variant="outlined"
        class="activator"
        density="compact"
        no-wrap
        :data-testid="TestId.insurance.planActivator"
      >
        <sp-icon slot="prepend" name="insurance-carrier-filled"></sp-icon>
        {{ title }}
        <sp-icon slot="append" name="popup-arrow-filled"></sp-icon>
      </sp-button>
    </template>
  </InsurancePlanFilter>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { useBreakpoints } from "#ce/composables/useBreakpoints";
import InsurancePlanFilter from "#ce/shared/filters/insurance-plan/components/InsurancePlanFilter.ce.vue";
import { booleanAttribute } from "#ce/utils/props";
defineProps({
  title: {
    type: String,
    default: "Check your insurance",
  },
  insurancePlan: {
    type: String,
    default: undefined,
  },
  nonClearable: booleanAttribute(),
});
const { ltModifiers } = useBreakpoints();

const breakpointModifierClass = computed(() => [...ltModifiers.value]);

const emit = defineEmits(["update:model-value", "insurance-changed"]);

function insuranceChanged(value) {
  emit("insurance-changed", value);
}
</script>

<style scoped lang="scss">
.activator {
  --sp-comp-button-border-radius: 12px;
  --sp-comp-button-outlined-border-style: dashed;
  --sp-comp-button-outlined-border-color: var(--sp-comp-insurance-plan-filter-outlined-activator-border-color, inherit);
  --sp-comp-button-prepend-icon-size: 20px;
  --sp-comp-button-append-icon-size: 20px;
  --font-family: var(--sp-sys-font-family-medium);

  &:hover {
    --sp-comp-button-outlined-border-style: solid;
  }
}
.filter {
  &.--lt-sm-screen {
    --filter-width: 100%;
  }
}
</style>
